<script setup>
import { computed, ref,onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import LocalStorage from '@/controller/LocalStorage.js';
import { useI18n } from "vue-i18n";
import YBtn from "@/components/common/form/YBtn/YBtn.vue";
import Notifications from '@/components/common/navbars/components/Notifications.vue';
import GlobalSearcher from "@/components/common/navbars/components/GlobalSearcher.vue";
import MazDropdown from 'maz-ui/components/MazDropdown';

const { t } = useI18n();
const router = useRouter();
const isHome = computed(() => router.currentRoute.value.path === '/')
const userColor = ref(LocalStorage.getColor());
let yautyData = ref("");
const userNick = ref("");
const userName = ref("");

if (localStorage.getItem('yautyData')) {
  yautyData = ref(JSON.parse(localStorage.getItem('yautyData')));
  userNick.value = yautyData.value.name.charAt(0).toUpperCase();
  userName.value = yautyData.value.name.charAt(0).toUpperCase() + yautyData.value.name.slice(1);
}

</script>

<template>

  <nav
    v-if="!$route.meta.hideNavbar"
    class="navbar navbar-desktop" :class="[{'hidden' : isHidden}, isHome ? 'navbar-home' : 'navbar-default']"
  >
      <div class="global-searcher-wrapper">
        <GlobalSearcher />
      </div>
    <div class="menu nav-item">
      <li class="navbar__item d-flex notifications-item">
            <Notifications />
          </li>
      <div class="user-dropdown desktop" id="userDropdown">
        <MazDropdown
            trigger="hover"
            size="xs"
            position="bottom right"
            no-chevron
            >
            <template #default>
                <div class="user-icon-wrapper">
                    <div class="user-icon" :title="$t('user.user')">
                        {{ userNick }}
                    </div>
                </div>
            </template>
            <template #dropdown>
                <div class="user-dropdown-body">
                    <div class="title">
                        <div class="title-label">
                            {{ userName }}
                        </div>
                    </div>
                    <hr class="undername-separator"/>
                    <div class="user-dropdown-actions">
                        <router-link to="/user" class="btn-header-route" :title="t('profileconfig')">
                                <div class="show-all-wrapper">
                                    <span>{{$t("user.profile")}}</span>
                                </div>
                        </router-link>
                        <router-link to="/logout" class="btn-header-route" :title="t('logout.logout')">
                                <div class="show-all-wrapper">
                                    <span>{{$t("logout.logout")}}</span>
                                </div>
                        </router-link>
                    </div>
                </div>
            </template>
        </MazDropdown>
    </div>

    </div>
  </nav>
</template>

<style lang="scss" scoped>
.user-dropdown-body{
    display: flex;
    flex-direction: column;
    padding: 1rem 1rem;
    min-height: 100px;
    min-width: 200px;
    .title{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .title-label{
            font: normal normal normal 26px/19px 'CircularStd-Bold';
            letter-spacing: 0px;
            color: #153440;
            margin-bottom: 1rem;
        }
    }
    .actions{
        display: flex;
        justify-content: flex-end;
        font-size: 11px;
        .mark-all-read{
            margin-bottom: 0.5rem;
        }
        .mark-all-read:hover{
            cursor: pointer;
            text-decoration: underline;
        }
        .light-grey{
            color: #cbd5e1;
        }
    }
    .notifications-list{
        flex-grow: 1;
        margin-top: 1rem;
    }
    .user-dropdown-actions{
        display: flex;
        flex-direction: column;
        margin-top: 1rem;
        justify-content: center;
        align-items: center;
        gap: 1.5rem;
        a{
            text-decoration: none;
            color: #153440;
            font: normal normal normal 16px/19px 'CircularStd-Bold';
            transition: color 0.2s;
            &:hover {
                color: v-bind(userColor);
            }
        }
    }
    .undername-separator{
        margin: 0;
        margin-top: -5px;
        margin-bottom: 5px;
        color: #a8b0ba;
    }
}



.navbar.navbar-desktop {
  * {
    font-family: 'CircularStd-Book';
  }
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  color: #515151;
  background-color: #ffffff;
  border-bottom: 1px solid #f5f5f5;
  height: 61px;
  position: relative;
  &__item{
    margin-left: 1rem;
  }
  .global-searcher-wrapper{
    margin-left: calc(5dvw + 50px);
    flex-grow: 1;
  }
}

.menu{
  display: flex;
  gap: 20px;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
  padding-right: 1.2dvw;
  .nav-item{
    padding: 0 10px;
  }
  a {
    display: block;
    width: 100%;
    color: #515151;

    cursor: pointer;
    text-decoration: none;
    font-weight: 600;
    &:nth-child(3) {
      border-bottom-left-radius: calc(0.375rem - 1px);
      border-bottom-right-radius: calc(0.375rem - 1px);
    }
    &:nth-child(1) {
      border-top-left-radius: calc(0.375rem - 1px);
      border-top-right-radius: calc(0.375rem - 1px);
    }
    &:hover {
      color: #0195d8;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .dropdown-menu[data-bs-popper] {
    left: -5.7rem;
    top: 5dvh;
  }
  .dropdown-menu {
    --bs-dropdown-zindex: 1000;
    --bs-dropdown-min-width: 10rem;
    --bs-dropdown-padding-x: 0;
    --bs-dropdown-padding-y: 0rem;
    --bs-dropdown-spacer: 0.125rem;
    --bs-dropdown-font-size: 1rem;
    --bs-dropdown-color: #212529;
    --bs-dropdown-bg: #fff;
    --bs-dropdown-border-color: var(--bs-border-color-translucent);
    --bs-dropdown-border-radius: 0.375rem;
    --bs-dropdown-border-width: 1px;
    --bs-dropdown-inner-border-radius: calc(0.375rem - 1px);
    --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
    --bs-dropdown-divider-margin-y: 0rem;
    --bs-dropdown-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    --bs-dropdown-link-color: #212529;
    --bs-dropdown-link-hover-color: #1e2125;
    --bs-dropdown-link-hover-bg: #e9ecef;
    --bs-dropdown-link-active-color: #fff;
    --bs-dropdown-link-active-bg: #0d6efd;
    --bs-dropdown-link-disabled-color: #adb5bd;
    --bs-dropdown-item-padding-x: 0.9rem;
    --bs-dropdown-item-padding-y: 0.9rem;
    --bs-dropdown-header-color: #6c757d;
    --bs-dropdown-header-padding-x: 1rem;
    --bs-dropdown-header-padding-y: 1rem;
    position: absolute;
    z-index: var(--bs-dropdown-zindex);
    min-width: var(--bs-dropdown-min-width);
    padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
    margin: 0;
    font-size: var(--bs-dropdown-font-size);
    color: var(--bs-dropdown-color);
    text-align: left;
    list-style: none;
    background-color: var(--bs-dropdown-bg);
    background-clip: padding-box;
    border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
    border-radius: var(--bs-dropdown-border-radius);
  }
  .branding__link {
    color: white;
    background-color: v-bind(userColor);
    height: 32px;
    width: 32px;
    text-align: center;
    border-radius: 30px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
  }  
  .user-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: v-bind(userColor);
    color: white;
    font: normal normal normal 18px/16px 'CircularStd-Bold';
    
  }
  
}

::v-deep .m-btn.--is-button.m-btn.--is-button.--transparent:not(:disabled):hover:not(:disabled):hover {
    background-color: transparent;
}
</style>
